//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'barOrder',
  components: {
    wx
  },
  data () {
    return {
      id:0,
      popUp:false,
      code:'',
      order:{
        log:[],
        factory:[],
        community:{}
      },
      pics:[],
      picPath:[],
      number:'',
    }
  },
  created(){
    this.config();
  },
  mounted(){
    this.code = this.$route.params.code;
    if(this.code){
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  methods:{
     searchOrder(orderNo){
        this.$router.push({name:'searchOrder',params:{code:orderNo}})
    },
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    that.code = res.resultStr.split(',')[1];
                    that.getOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode",
                        "chooseImage",
                        "uploadImage",
                    ]
                });
            }
        })
    },
    uploadFile(){
        let that = this;
        wx.chooseImage({
            count: 9,
            sizeType: ['original', 'compressed'], 
            sourceType: ['album', 'camera'], 
            success: function (res) {
                that.uploadImg(res.localIds);
            }
        });
    },
    uploadImg(localIds){
        let that = this;
        let localId = localIds.pop();
        wx.uploadImage({
            localId: localId, 
            success: function (res) {
            that.$api.uploadsImgOss({serverId:res.serverId,path:'record'}).then((res)=>{
                if(res){
                    that.picPath.unshift(res.data.pathName);
                    that.pics.unshift(res.data.saveName);
                    if(localIds.length > 0){
                      that.uploadImg(localIds);
                    }else{
                      that.addImg();
                    }
                }
            })
            }
        });
    },
    addImg(){
      let that = this;
        that.$func.startLoading();
          let picsStr = that.pics.join(',');
          that.$api.operatePhoto({code:this.code,imgs:picsStr}).then((res)=>{
            if(res){
              // that.$func.endLoading();
              that.$func.showToast('添加成功');
            } 
        })  
        that.$func.endLoading();
    },
    delImg(index){
      let that = this;
      this.$func.confirm('确定删除吗？','提示',()=>{
         that.$func.startLoading();
            that.pics.splice(index,1);
            let picsStr = that.pics.join(',');
            that.$api.operatePhoto({code:this.code,imgs:picsStr}).then((res)=>{
              if(res){
                that.picPath.splice(index,1);
                that.$func.endLoading();
              } 
          })  
      })
    },
    showPic(urls,url){
      wx.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder(){
      let that = this;
      if(!this.code){
        that.$func.showToast('衣物条码无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({code:this.code}).then((res)=>{
        if(res){
          that.order = res.data;
          this.picPath = res.data.img_path;
          this.pics = res.data.item_imgs;
          that.$func.endLoading();
        } 
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/clothePhoto.vue